import React from 'react';

import ActionButton from 'jbc-front/components/ActionButton';
import MinusCircle from 'jbc-front/components/icons/MinusCircle';
import { useTranslation } from 'react-i18next';

const CancelActionBtn = props => {
  const { t } = useTranslation();
  const { onClick, label = t('buttons.ActionBtn.CancelActionBtn.Cancel'), ...rest } = props;
  return (
    <ActionButton as="button" icon={<MinusCircle />} onClick={onClick} {...rest}>
      {label}
    </ActionButton>
  );
};

export default CancelActionBtn;
